export class Cleared {
    static options() {
        return [
            {
                value: 'na',
                text: 'N/A'
            },
            {
                value: 'yes',
                text: 'Yes'
            },
            {
                value: 'no',
                text: 'No'
            },
            {
                value: 'further_work',
                text: 'Futher Work Required'
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/helpers/cleared-options.js